<!-- 由 suu 创建于 2025-07-29 星期二 -->
<template>
  <div class="nearby-shop" v-if="shopList && shopList.length > 0">
    <!-- 导航栏 -->
    <ShopNavBar
      id="list-bar"
      :opacity="navBarOpacity"
      @selectCity="handleSelectCity"
    />

    <!-- 头部图片 -->
    <img class="nav-top-img" :src="cityObj[curCityRegionId].topImg" alt="" />
    <!-- 门店列表 -->
    <div class="shop-list">
      <ShopListItem
        v-for="(item, index) in shopList.filter(
          (item) => !hideShopList.includes(item.id)
        )"
        :key="item.id"
        :shopInfo="item"
        :shopIndex="index"
        @click.native="handleShopClick(item)"
      />
      <!-- 期待更多 -->
      <img
        class="list-default"
        :class="{ 'list-default-margin': shopList.length < 2 }"
        v-if="shopList.length < 5"
        src="https://cdnvue.gymcity.com.cn/uploads/25shop-list-default"
        alt=""
      />
    </div>
    <!-- 城市选择 -->
    <van-action-sheet
      v-model="cityShow"
      :actions="citys"
      close-on-click-action
      cancel-text="取消"
      @select="handleSelectCityConfirm"
    />
  </div>
  <vLoading v-else />
</template>

<script>
import ShopNavBar from './ponents/ShopNavBar.vue'
import ShopListItem from './ponents/ShopListItem.vue'

export default {
  name: 'nearby-shop',

  components: {
    ShopNavBar,
    ShopListItem
  },

  props: {},

  data() {
    return {
      shopList: [],
      navBarOpacity: 0,
      cityObj: {
        4301: {
          topImg: 'https://cdnvue.gymcity.com.cn/uploads/25shop-list-top-cs'
        },
        3201: {
          topImg: 'https://cdnvue.gymcity.com.cn/uploads/25shop-list-top-nj'
        },
        3205: {
          topImg: 'https://cdnvue.gymcity.com.cn/uploads/25shop-list-top-sz'
        },
        4403: {
          topImg:
            'https://cdnvue.gymcity.com.cn/uploads/25shop-list-top-shenZhen'
        }
      },
      cityShow: false, // 城市选择
      curCityRegionId: null
    }
  },

  computed: {
    // 开业预热 1.16之前门店列表不显示 240 龙江尚悦天地私教馆
    //  2.28 242 皇庭中心私教馆
    hideShopList() {
      let arr = []
      // if (new Date() < new Date('2026/01/16')) {
      //   arr.push(240)
      // }
      // if (new Date() < new Date('2026/02/28')) {
      //   arr.push(242)
      // }
      return arr
    },
    citys() {
      //  城市列表
      const citys = this.$store.state.user.user.citys || null
      if (citys) {
        citys.forEach((item) => {
          item.name = item.cityname
        })
      }
      return citys
    }
  },

  watch: {},

  created() {
    this.getShopList()
  },

  mounted() {
    document.addEventListener('scroll', this.bindScroll, {
      passive: false
    })
  },

  destroyed() {
    document.removeEventListener('scroll', this.bindScroll)
  },

  methods: {
    /**
     * 处理门店点击事件
     * @param {Object} item - 门店信息
     */
    handleShopClick(item) {
      this.$store.commit('setCurShop', item)
      this.$router.push(`/nearby-shop-details?shopid=${item.id}`)
    },

    /**
     * 获取门店列表数据
     */
    async getShopList() {
      try {
        const location = this.$store.state.location
        let lat = location?.lat || ''
        let lng = location?.lng || ''
        const regionCode = this.curCityRegionId || ''
        if (!lat || !lng) {
          try {
            const locationRes = await this.$betterwe.requestLocation()
            if (locationRes.errorCode == 0) {
              lat = locationRes.latitude
              lng = locationRes.longitude
            }
          } catch (error) {
            console.log('门店列表获取经纬度失败', error)
          }
        }
        const res = await this.$http.get('member/index?a=getShopListByApp', {
          lat,
          lng,
          regionCode
        })

        if (res.data.code === 200) {
          const list = res.data.data || []
          if (list.length > 0) {
            this.curCityRegionId = list[0].region_id

            // 标记最近的门店
            if (list[0].distance) {
              list[0]['is_near'] = true
            }

            // 将已去过的门店排到前面
            const goItem = list.find((item) => item.is_go)
            if (goItem) {
              const goIndex = list.indexOf(goItem)
              list.splice(goIndex, 1)
              list.unshift(goItem)
            }

            this.shopList = list
          }
        }
      } catch (error) {
        console.error('获取门店列表失败:', error)
      }
    },

    /**
     * 处理城市选择确认
     * @param {Object} item - 选中的城市信息
     */
    handleSelectCityConfirm(item) {
      if (item.region_id !== this.curCityRegionId) {
        this.curCityRegionId = item.region_id
        // 同步更新全局当前城市，保证后续预约/约课页、城市选择器高亮读到的是新城市
        this.$store.commit('setCurCity', item)
        this.getShopList()
        this.cityShow = false
        // 切换城市后，同步重新获取门店排课列表  门店详情页有快速约课功能 跳转约课列表页自动定位到对应门店
        this.$http.homeinfo('', '', item.region_id)
        this.$http.userinfo('', '', item.region_id)
      }
    },

    /**
     * 处理城市选择按钮点击
     */
    handleSelectCity() {
      if (this.citys && this.citys.length > 0) {
        this.cityShow = true
      }
    },

    /**
     * 监听页面滑动 控制nav不透明度
     * @param {Event} e - 滚动事件
     */
    bindScroll(e) {
      const minHeight = 50
      const maxHeight = 150
      const scroll = window.scrollY

      if (scroll < minHeight) {
        this.navBarOpacity = 0
      } else if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        const percent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(percent.toFixed(2))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.nearby-shop {
  width: 100vw;
  box-sizing: border-box;
  position: relative;

  .nav-top-img {
    width: 100vw;
    min-height: vw(210);
  }

  .shop-list {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 12px 12px 0px 0px;
    padding: 22px 12px 40px 20px;
    position: relative;
    z-index: 2;
    margin-top: -17px;
    .list-default {
      width: vw(214);
      margin: 0 auto;
      margin-top: vw(20);
      &.list-default-margin {
        margin-top: vw(100);
      }
    }
  }
}
</style>
